// import SelectMetaObjective from "@/views/campains/meta/SelectMetaObjective.vue";
// import MetaIndex from "@/views/campains/meta/MetaIndex.vue";
// import MetaSecoundStep from "@/views/campains/meta/MetaSecoundStep.vue";
// import MestaLastStep from "@/views/campains/meta/MestaLastStep.vue";
// import SelectAcountId from "@/views/campains/meta/SelectAcountId.vue";

const metaRoutes = [
  {
    path: "/meta",
    name: "SelectMetaObjective",
    component: () => import("@/views/campains/meta/SelectMetaObjective.vue"),
    meta: {
      title: "Meta",
      description: "",  
        permissions: [
          "campaign-ads.create",
          "campaign-ads.read",
          "campaign-ads.update",
          "campaign-ads.delete",
        ],
    },
  },
  {
    path: "/meta-adsmanager",
    name: "MetaIndex",
    component: () => import("@/views/campains/meta/MetaIndex.vue"),
    meta: {
      title: "Meta",
      description: "",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/meta-adsmanager/manage",
    name: "MetaSecoundStep",
    component: () => import("@/views/campains/meta/MetaSecoundStep.vue"),
    meta: {
      title: "Meta",
      description: "",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  {
    path: "/meta/manage/ads",
    name: "MetaLastStep",
    component: () => import("@/views/campains/meta/MestaLastStep.vue"),
    meta: {
      title: "Meta",
      description: "",
      permissions: [
        "campaign-ads.create",
        "campaign-ads.read",
        "campaign-ads.update",
        "campaign-ads.delete",
      ],
    },
  },
  // {
  //   path: "/meta/manage/ads/account_id",
  //   name: "SelectAcountId",
  //   component: () => import("@/views/campains/meta/SelectAcountId.vue"),
  //   meta: {
  //     title: "Meta",
  //     descriptors: "",
      
  //     permissions: [
  //       "campaign-ads.create",
  //       "campaign-ads.read",
  //       "campaign-ads.update",
  //       "campaign-ads.delete",
  //     ],
  //   },
  // },
];

export default metaRoutes;
